import React from 'react';
import { Helmet } from 'react-helmet';

const HideBodyScroll = () => (
  <Helmet>
    <html
      lang="en"
      data-hide-scroll="true"
    />
  </Helmet>
);

export default HideBodyScroll;
